
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password/reset-password.lazy",
      function () {
        return require("private-next-pages/reset-password/reset-password.lazy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reset-password/reset-password.lazy"])
      });
    }
  